"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveAccount = exports.getRememberedAccounts = exports.deleteRememberedAccount = exports.deleteAllRememberedAccounts = void 0;
var _constants = require("./constants");
const getRememberedAccounts = () => {
  try {
    const accounts = window.localStorage.getItem(_constants.STORAGE_KEY);
    if (!accounts) {
      return [];
    }
    return JSON.parse(accounts);
  } catch (error) {
    return [];
  }
};
exports.getRememberedAccounts = getRememberedAccounts;
const saveAccount = account => {
  try {
    const rememberedAccounts = getRememberedAccounts();
    const preparedAccounts = rememberedAccounts.filter(_ref => {
      let {
        value
      } = _ref;
      return value !== account.value;
    });
    const accounts = [account, ...preparedAccounts];
    const value = JSON.stringify(accounts);
    window.localStorage.setItem(_constants.STORAGE_KEY, value);
    return accounts;
  } catch (error) {
    return [];
  }
};
exports.saveAccount = saveAccount;
const deleteRememberedAccount = account => {
  try {
    const rememberedAccounts = getRememberedAccounts();
    const accounts = rememberedAccounts.filter(_ref2 => {
      let {
        value
      } = _ref2;
      return value !== account.value;
    });
    const value = JSON.stringify(accounts);
    window.localStorage.setItem(_constants.STORAGE_KEY, value);
    return accounts;
  } catch (error) {
    return [];
  }
};
exports.deleteRememberedAccount = deleteRememberedAccount;
const deleteAllRememberedAccounts = () => {
  window.localStorage.removeItem(_constants.STORAGE_KEY);
};
exports.deleteAllRememberedAccounts = deleteAllRememberedAccounts;